import {
	RESET_FILTER, ADD_FILTER_OPTION
} from '../actions/filter-options';

function filterOptions(state = [], action){
	switch(action.type){
		case RESET_FILTER:
			return [];

		case ADD_FILTER_OPTION:
			let option = {
				name: action.name,
				label: action.label,
				options: action.options
			};
			return [...state, option];

		default:
			return state;
	}
}

export default filterOptions;
